import { render, staticRenderFns } from "./DepositMethod.vue?vue&type=template&id=65870b8c&lang=pug"
import script from "./DepositMethod.vue?vue&type=script&lang=js"
export * from "./DepositMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports